import { Button, Stack } from '@mui/material'

import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type ButtonCellProps = {
  onSubmit: () => void
  isSubmitting: boolean
}
export const ButtonCell: Cell<ButtonCellProps> = ({
  onSubmit,
  isSubmitting,
}) => {
  const { t } = useTranslation('firstComeFirstServedConfirmation')
  const { router, generatePath, routerPages } = useRouter<{
    preSaleId: string
  }>()

  return (
    <CellFrame sx={{ py: 4 }}>
      <Stack spacing={4} alignItems="center">
        <Button
          size="large"
          loading={isSubmitting}
          sx={{ width: 212 }}
          onClick={onSubmit}
        >
          {t('buy', '購入する')}
        </Button>
        <Button
          variant="text"
          size="small"
          sx={{ width: 212 }}
          onClick={() =>
            router.goBack(
              generatePath(routerPages.FirstComeFirstServedDetail, {
                preSaleId: router.query.preSaleId,
              })
            )
          }
        >
          {t('back', '戻る')}
        </Button>
      </Stack>
    </CellFrame>
  )
}
